import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import moliLogo from '../assests/Images/moli-logo.png';
import APICall from "../services/ApiCall";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";


const Join = () => {
    // Define sessionId in state
    const [sessionId, setSessionId] = useState('');
    const navigate = useNavigate();

    // Update sessionId state when input changes
    const handleSessionIdChange = (e) => {
        setSessionId(e.target.value);
    };

    const handleJoin = async () => {
        if (!sessionId.trim()) {
            alert("Please enter a session ID!");
            return;
        }

        try {
            const apiCall = new APICall(); // Correct instantiation
            const response = await apiCall.validateSessionId(sessionId);
            // Check if response contains avatar details
            if (response && response.avatar) {
                const { avatar_name, avatar_img } = response.avatar;
                const jobId = response.job_id;

                // Store avatar details in cookies
                Cookies.set("avatarInfo", JSON.stringify({ avatar_name, avatar_img }), { expires: 0.25 }); // Expires in 7 days
                navigate(`/enterRoomPage?sessionId=${sessionId}&jobId=${jobId}`);
            } else {
                alert("No avatar information found in the response.");
            }
        } catch (error) {
            console.error("Error validating session:", error);
            alert("Failed to validate the session. Please try again.");
        }
    };

    return (
        <>
            <Container 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh', 
                    backgroundColor: '#f8f9fa' 
                }}
            >
                <Row className="justify-content-center">
                    <Col xs={12} md={6} className="text-center">
                        <img
                            src={moliLogo}
                            alt="Moli Logo"
                            style={{ 
                                width: '100%', 
                                marginBottom: '15px',
                                maxWidth: '300px' 
                            }}
                        />
                    </Col>
                </Row>
                <Row className="justify-content-center mt-4">
                    <Col xs={12} md={6} className="text-center">
                        <label 
                            htmlFor="sessionId" 
                            style={{ 
                                display: 'block', 
                                marginBottom: '15px', 
                                fontSize: '25px', 
                                color: 'black' 
                            }}
                        >
                            Enter your session id..!
                        </label>
                        <input
                            type="text"
                            id="sessionId"
                            value={sessionId} // Bind state to the input value
                            onChange={handleSessionIdChange} // Update state on input change
                            placeholder="Session ID"
                            style={{ 
                                width: '100%', 
                                padding: '10px', 
                                marginBottom: '15px', 
                                fontSize: '20px' ,
                                color: 'black',
                                backgroundColor: 'white',
                                border: '1px solid grey', 
                                borderRadius: '5px' 
                            }}
                        />
                        <button
                            type="button"
                            className="btn btn-primary"
                            style={{ 
                                padding: '5px 20px', 
                                fontSize: '20px',
                                width:'350px',
                                height: '40px',
                            }}
                            onClick={handleJoin} // Attach the click handler
                        >
                            Join
                        </button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Join;
